<template>
  <div>
    <!-- 搜索框 -->
    <a-card title="服务流控配置">
        <div slot="extra">
            <a-button @click="handleGoBack" style="margin-right:20px;">返回</a-button>

            <a-button type="primary" @click="handleNewRiskConfig">新建</a-button>



        </div>

    </a-card>

    <!-- 系统列表 -->
    <a-table :columns="columns" :data-source="data"  :pagination="false" :loading="tLoading" rowKey="id" >
         <span slot="domain" slot-scope="text">{{domainName[text]}}</span>
        <span slot="authflag" slot-scope="text">{{flagname[text]}}</span>
        <span slot="isoverall" slot-scope="text">{{isOverAllName[text]}}</span>
        <authedStrd slot="riskconfigs" slot-scope="text" :authedStr="text"></authedStrd>
      <template slot="operation" slot-scope="text, record">
        <div >
         <span>
           <a-button type="link" @click="handle_auth_edit(record)">编辑</a-button>
          </span>
          <span>
            <a-popconfirm  @confirm="() => handle_auth_delete(record)" >
                <template slot="title">
                    <p>{{ '确认将【' + record.appcode+ '】删除？' }}</p>
                </template>
            <a>删除配置    </a>
            </a-popconfirm>
          </span>
        </div>


      </template>
    </a-table>

   <a-pagination class="my_pagenation" v-model="pagination.current" :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

  </div>
</template>
<script>
import authedStrd from "./tableItems";
const data = [];
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',

};
const flagname = {
    '1':'开启',
    '0':'关闭',

};
const isOverAllName = {
    '1':'是',
    '0':'否',

};
let pagination={
    total:0,
    pageSize:0,
    current:1,
}
const columns = [
    {
        title: "序号",
        width: 60,
        align: "center",
        customRender: (text, record, index) => {
            let { current, pageSize } = pagination;
            return (Number(current) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: '领域',
        dataIndex: 'domain',
        align: 'center',
        scopedSlots: { customRender: 'domain' },
        width: 80,
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
        width: 80,
    },
    {
        title: '消费方应用编码',
        dataIndex: 'authappcode',
        align: 'center',
        width: 100,
    },
    {
        title: '服务编码',
        dataIndex: 'servicekey',
        align: 'center',
        width: 100,
    },
    {
        title: '服务配置',
        dataIndex: 'serviceconfig',
        align: 'center',
        width: 100,
    },

    {
        title: '是否开启',
        dataIndex: 'authflag',
        align: 'center',
        scopedSlots: { customRender: 'authflag' },
        width: 80,
    },
    {
        title: '是否全局',
        dataIndex: 'isoverall',
        align: 'center',
        scopedSlots: { customRender: 'isoverall' },
        width: 80,
    },
    {
        title: '配置项',
        dataIndex: 'riskconfig',
        align: 'left',
        width: 240,
        scopedSlots: { customRender: 'riskconfigs' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            form: this.$form.createForm(this),
            data,
            columns,
            pagination,
            domainName,
            isOverAllName,
            flagname,
            tLoading:true,
            currentItemList:'',
            datasource:{
                isShow:false,
                authedStr:''
            }
        };
    },
    methods: {

        handleGoBack(){
            this.$router.back(-1);
        },
        handlePageChange(c_p){
            this.getAuthedAppList(c_p)
        },
        getAuthedAppList(cpage){

            const { query} = this.$route;
            let c_params = {
                ...query
            }
            c_params.page =cpage ? cpage : 1;
            c_params.pageSize = this.pagination.pageSize;
            c_params.urlparams = false;
            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/queryriskconfig",
                params:c_params
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                let result = res.data.data;
                if(result){
                    this.data = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.current = parseInt(result.page);
                }
            })
        },
        handle_auth_edit(ritem){
            this.$router.push({
                path: "editriskconfig",
                query: {servicekey:ritem.servicekey,authappcode:ritem.authappcode}
            });
        },
        handle_auth_delete(item){
            this.tLoading = true;
            this.$store.dispatch({
                type: "servicekey/deleteriskconfig",
                params:{id:item.id,appcode:item.appcode,servicekey:item.servicekey,urlparams:false}
            }).then((res)=>{
                console.log(res);
                this.tLoading = false;
                if(res.data.success == '1'){
                    this.getAuthedAppList()
                }
            })
        },
        handleSearchReset(){
            this.$store.dispatch({
                type: "servicekey/getEmptySearch",
                showMsg: true
            })
        },
        handleNewRiskConfig(){
            const {query} = this.$route;
            this.$router.push({
                path: "addriskconfig",
                query: {...query}
            });
        },
        handleSubmit(e){
            e.preventDefault();
            this.getAuthedAppList()
        },

    },
    computed:{

    },
    components:{
        authedStrd
    },
    mounted(){
        this.getAuthedAppList();
    }
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
td{
  padding: 10px 10px;
}
</style>
